import React, { memo, useEffect, useRef } from 'react';
import { createSidetab } from '@typeform/embed';
import colorVars from '@farmers-fridge/ui-library/dist/colors.module.css';
import getIdFromUrl from './getIdFromEmbedUrl';
import { renderIconString } from '../iconMap';
import '@typeform/embed/build/css/sidetab.css';
import styles from './Sidetab.module.css';

/** @param {FF.ContentfulTypeform} props */
function Sidetab({ buttonIcon, buttonText, buttonType, formEmbedUrl }) {
  /**  @type {React.MutableRefObject<HTMLDivElement|null>} errorMsgRef */
  const container = useRef(null);
  useEffect(() => {
    if (container.current) {
      const ref = createSidetab(getIdFromUrl(formEmbedUrl), {
        container: container.current,
        buttonColor:
          buttonType === 'Secondary'
            ? colorVars.color_white_100
            : colorVars.color_green_leaf,
        buttonText,
        customIcon: `${renderIconString(
          buttonIcon?.name,
          buttonType === 'Secondary' ? styles.greenIcon : styles.whiteIcon,
        )}`,
      });

      return () => {
        ref.unmount();
      };
    }
    return () => {};
  }, []);

  return (
    <div
      className={buttonType === 'Secondary' ? styles.whiteSidetab : ''}
      ref={container}
    />
  );
}

export default memo(Sidetab);
